module.exports = __webpack_public_path__ + "img/jack-o-lantern.84f56452.svg";